import "core-js/modules/es.array.reverse.js";
var _class, _class2, _WebProcessingServiceCatalogGroup;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import i18next from "i18next";
import { action, computed, runInAction, makeObservable } from "mobx";
import URI from "urijs";
import filterOutUndefined from "../../../Core/filterOutUndefined";
import replaceUnderscores from "../../../Core/replaceUnderscores";
import runLater from "../../../Core/runLater";
import TerriaError from "../../../Core/TerriaError";
import CatalogMemberMixin from "../../../ModelMixins/CatalogMemberMixin";
import GetCapabilitiesMixin from "../../../ModelMixins/GetCapabilitiesMixin";
import GroupMixin from "../../../ModelMixins/GroupMixin";
import UrlMixin from "../../../ModelMixins/UrlMixin";
import { InfoSectionTraits } from "../../../Traits/TraitsClasses/CatalogMemberTraits";
import WebProcessingServiceCatalogGroupTraits from "../../../Traits/TraitsClasses/WebProcessingServiceCatalogGroupTraits";
import CommonStrata from "../../Definition/CommonStrata";
import CreateModel from "../../Definition/CreateModel";
import createStratumInstance from "../../Definition/createStratumInstance";
import LoadableStratum from "../../Definition/LoadableStratum";
import proxyCatalogItemUrl from "../proxyCatalogItemUrl";
import WebProcessingServiceCapabilities from "./WebProcessingServiceCapabilities";
import WebProcessingServiceCatalogFunction from "./WebProcessingServiceCatalogFunction";
let GetCapabilitiesStratum = (_class = class GetCapabilitiesStratum extends LoadableStratum(WebProcessingServiceCatalogGroupTraits) {
  constructor(model, capabilities) {
    super();
    this.model = model;
    this.capabilities = capabilities;
    makeObservable(this);
  }
  duplicateLoadableStratum(model) {
    return new GetCapabilitiesStratum(model, this.capabilities);
  }
  static async load(model) {
    if (model.getCapabilitiesUrl === undefined) {
      throw new TerriaError({
        title: i18next.t("models.webProcessingServiceCatalogGroup.missingUrlTitle"),
        message: i18next.t("models.webProcessingServiceCatalogGroup.missingUrlMessage")
      });
    }
    const capabilities = await WebProcessingServiceCapabilities.fromUrl(proxyCatalogItemUrl(model, model.getCapabilitiesUrl, model.getCapabilitiesCacheDuration));
    const stratum = new GetCapabilitiesStratum(model, capabilities);
    return stratum;
  }
  get name() {
    const title = this.capabilities.ServiceIdentification.Title;
    if (title !== undefined) {
      return replaceUnderscores(title);
    }
  }
  get info() {
    const result = [];
    const service = this.capabilities.ServiceIdentification;
    if (service.Abstract) {
      result.push(createStratumInstance(InfoSectionTraits, {
        name: i18next.t("models.webProcessingServiceCatalogGroup.abstract"),
        content: service.Abstract
      }));
    }
    if (service.AccessConstraints && !/^none$/i.test(service.AccessConstraints)) {
      result.push(createStratumInstance(InfoSectionTraits, {
        name: i18next.t("models.webProcessingServiceCatalogGroup.accessConstraints"),
        content: service.AccessConstraints
      }));
    }

    // Show the Fees if it isn't "none".
    if (service.Fees && !/^none$/i.test(service.Fees)) {
      result.push(createStratumInstance(InfoSectionTraits, {
        name: i18next.t("models.webProcessingServiceCatalogGroup.fees"),
        content: service.Fees
      }));
    }
    const serviceProvider = this.capabilities.ServiceProvider;
    if (serviceProvider) {
      var _serviceProvider$Prov;
      if (serviceProvider.ProviderName) {
        result.push(createStratumInstance(InfoSectionTraits, {
          name: i18next.t("models.webProcessingServiceCatalogGroup.providerName"),
          content: serviceProvider.ProviderName
        }));
      }
      if ((_serviceProvider$Prov = serviceProvider.ProviderSite) !== null && _serviceProvider$Prov !== void 0 && _serviceProvider$Prov["xlink:href"]) {
        result.push(createStratumInstance(InfoSectionTraits, {
          name: i18next.t("models.webProcessingServiceCatalogGroup.providerSite"),
          content: serviceProvider.ProviderSite["xlink:href"]
        }));
      }
    }
    return result;
  }
  get members() {
    var _this$capabilities$Pr, _this$capabilities$Pr2;
    return filterOutUndefined((_this$capabilities$Pr = (_this$capabilities$Pr2 = this.capabilities.ProcessOfferings) === null || _this$capabilities$Pr2 === void 0 ? void 0 : _this$capabilities$Pr2.map(process => this.getProcessId(process))) !== null && _this$capabilities$Pr !== void 0 ? _this$capabilities$Pr : []);
  }
  getProcessId(process) {
    if (this.model.uniqueId !== undefined) {
      return "".concat(this.model.uniqueId, "/").concat(process.Identifier);
    }
  }
  createMembersForProcesses() {
    var _this$capabilities$Pr3;
    (_this$capabilities$Pr3 = this.capabilities.ProcessOfferings) === null || _this$capabilities$Pr3 === void 0 || _this$capabilities$Pr3.forEach(process => this.createMemberForProcess(process));
  }
  createMemberForProcess(process) {
    const processId = this.getProcessId(process);
    if (processId === undefined) {
      return;
    }
    const memberModel = this.getOrCreateWPSCatalogFunction(processId);

    // Replace the stratum inherited from the parent group.
    memberModel.strata.delete(CommonStrata.definition);
    memberModel.setTrait(CommonStrata.definition, "name", process.Title);
    memberModel.setTrait(CommonStrata.definition, "url", this.model.url);
    memberModel.setTrait(CommonStrata.definition, "identifier", process.Identifier);
    memberModel.setTrait(CommonStrata.definition, "description", process.Abstract);
  }
  getOrCreateWPSCatalogFunction(id) {
    const terria = this.model.terria;
    const existingModel = terria.getModelById(WebProcessingServiceCatalogFunction, id);
    if (existingModel !== undefined) {
      return existingModel;
    }
    const wpsItem = new WebProcessingServiceCatalogFunction(id, terria);
    terria.addModel(wpsItem);
    return wpsItem;
  }
}, _applyDecoratedDescriptor(_class, "load", [action], Object.getOwnPropertyDescriptor(_class, "load"), _class), _applyDecoratedDescriptor(_class.prototype, "name", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "name"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "info", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "info"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "members", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "members"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createMemberForProcess", [action], Object.getOwnPropertyDescriptor(_class.prototype, "createMemberForProcess"), _class.prototype), _class);
let WebProcessingServiceCatalogGroup = (_class2 = (_WebProcessingServiceCatalogGroup = class WebProcessingServiceCatalogGroup extends GroupMixin(GetCapabilitiesMixin(UrlMixin(CatalogMemberMixin(CreateModel(WebProcessingServiceCatalogGroupTraits))))) {
  constructor() {
    super(...arguments);
    makeObservable(this);
  }
  get type() {
    return WebProcessingServiceCatalogGroup.type;
  }
  get typeName() {
    return i18next.t("models.webProcessingServiceCatalogGroup.typeName");
  }
  async forceLoadMetadata() {
    const stratum = await GetCapabilitiesStratum.load(this);
    runInAction(() => {
      this.strata.set(GetCapabilitiesMixin.getCapabilitiesStratumName, stratum);
    });
  }
  async forceLoadMembers() {
    const getCapabilitiesStratum = this.strata.get(GetCapabilitiesMixin.getCapabilitiesStratumName);
    if (getCapabilitiesStratum) {
      await runLater(() => getCapabilitiesStratum.createMembersForProcesses());
    }
  }
  get defaultGetCapabilitiesUrl() {
    return this.url === undefined ? undefined : new URI(this.url).search({
      service: "WPS",
      request: "GetCapabilities",
      version: "1.0.0"
    }).toString();
  }
}, _defineProperty(_WebProcessingServiceCatalogGroup, "type", "wps-getCapabilities"), _WebProcessingServiceCatalogGroup), _applyDecoratedDescriptor(_class2.prototype, "defaultGetCapabilitiesUrl", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "defaultGetCapabilitiesUrl"), _class2.prototype), _class2);
export { WebProcessingServiceCatalogGroup as default };